import { render, staticRenderFns } from "./dharma.vue?vue&type=template&id=4d9c3de2&scoped=true"
import script from "./dharma.vue?vue&type=script&lang=js"
export * from "./dharma.vue?vue&type=script&lang=js"
import style0 from "./dharma.vue?vue&type=style&index=0&id=4d9c3de2&prod&scoped=true&lang=less"
import style1 from "./dharma.vue?vue&type=style&index=1&id=4d9c3de2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9c3de2",
  null
  
)

export default component.exports